import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from './base-query';

const vehicleAddonsAPI = createApi({
    reducerPath: "vehicleAddonsAPI",
    baseQuery,
    tagTypes: ["babySeatPrice"],
    endpoints: (builder) => ({

        // GET /api/v1/vehicle/baby-seat-price
        getBabySeatPrice: builder.query({
            query: () => ({
                url: `/vehicle/baby-seat-price`,
                method: "GET",
            }),
            transformResponse: (response) => response?.data?.price,
            providesTags: ["babySeatPrice"],
        }),

        // PATCH /api/v1/vehicle/baby-seat-price
        updateBabySeatPrice: builder.mutation({
            query: ({ price }) => ({
                url: `/vehicle/baby-seat-price`,
                method: "PATCH",
                body: { price },
            }),
            transformResponse: (response) => response,
            invalidatesTags: ["babySeatPrice"],
        }),
    }),
});

export const {
    useGetBabySeatPriceQuery,
    useUpdateBabySeatPriceMutation,
} = vehicleAddonsAPI;

export default vehicleAddonsAPI;
